module.exports = __webpack_public_path__ + "img/zko1.7cd06df0.jpg";